import React, { useEffect, useState, useContext, useRef } from "react";
import Navbar from "../../layout/Navbar/Navbar";
import Sidebar from "../../layout/Sidebar/SideBar.jsx";
import Context from "../../context/Context";
import { FormApont } from "./components/FormApont";
import "./styles.css"
// import Navbar from "../../components/SideBar/Navbar.jsx";



export default function Reprocess() {

  return (
    <>
      {/* <Navbar/> */}

      {/* <Navbar />
      <Sidebar /> */}
      {/* <div className={`app_body`}>
      </div> */}

      <Navbar />
      <Sidebar />

      <FormApont />
    </>
  );
}
